export default "__VITE_ASSET__1218f7a1__"